export enum AppSettings {
    signalR = "AlertNotification",
    appName = 'Mylion'
}